<form 
    (ngSubmit)="$event.preventDefault(); saveDepression();"
    [formGroup]="depressionForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="h-full w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Depression
        </h2>
        <div class="w-full flex flex-col items-center gap-4 pb-4"> 

            <div *ngFor="let question of radioQuestions" class="w-full flex flex-col gap-4">
                <div class="w-full flex flex-col items-start text-start">
                    <div class="w-full font-semibold">
                        <p>{{ question.questionText }}</p>
                    </div>
                    <div class="w-full flex items-start gap-2">
                        <div>
                            <input type="radio" [id]="question.id + '_yes'" [value]="yesNo.Yes" class="hidden peer"
                                   [formControlName]="question.formControlName">
                            <label [for]="question.id + '_yes'"
                                   class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                Yes
                            </label>
                        </div>
                        <div>
                            <input type="radio" [id]="question.id + '_no'" [value]="yesNo.No" class="hidden peer"
                                   [formControlName]="question.formControlName">
                            <label [for]="question.id + '_no'"
                                   class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                No
                            </label>
                        </div>
                    </div>            
                </div>
                <div *ngIf="depressionForm.get(question.formControlName)?.value === yesNo.Yes" class="w-full flex flex-col items-center text-start">
                    <div class="w-full font-semibold">
                        <p>If yes, please explain: *</p>
                    </div>
                    <div class="w-full flex flex-col items-center">
                        <textarea [formControlName]="question.infoFormControlName"
                                    rows="3"
                                    class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                    placeholder="Explain..."></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.depressionForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.depressionForm.valid
                }"
                [disabled]="this.depressionForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>